import { Controller } from "stimulus"
import Rails from "@rails/ujs"

export default class extends Controller {

  flash(message, type) {
    return `<div class="alert alert-${type}" role="alert">${message}</div>`
  }

  send(event) {
    event.preventDefault()

    let params = new FormData(this.element)

    Rails.ajax({
      type: 'POST',
      url: '/kontakt',
      data: params,
      success: (data) => {
        const form = this.element
        form.reset()
        form.querySelector('.form-inner').classList.add('d-none')
        if (form.querySelector('.alert-danger')) {
          form.querySelector('.alert-danger').remove()
        }
        form.insertAdjacentHTML(
          'afterbegin',
          this.flash('Vielen Dank für Ihre Anfrage. Wir werden uns umgehend bei Ihnen melden!', 'success')
        )
      },
      error: (data) => {
        const form = this.element
        if (form.querySelector('.alert-danger')) {
          form.querySelector('.alert-danger').remove()
        }
        form.insertAdjacentHTML(
          'afterbegin',
          this.flash('Konnte das Formular nicht abschicken. Bitte prüfen Sie Ihre Angaben.', 'danger')
        )
        let button = form.querySelector('button')
        button.disabled = false
        button.innerText = 'Abschicken'
      }
    })
  }

}
